/*** Importations *********************************************************************************/

import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import smoothscroll from 'smoothscroll-polyfill';


// Libraries

// import InfiniteScroll from 'infinite-scroll';
import GLightbox from 'glightbox/dist/js/glightbox.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-upgrade';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import Swiper from 'swiper';
import {
	Autoplay,
	Pagination,
	Navigation,
	// EffectFade
} from 'swiper/modules';
// import { CountUp } from 'countup.js';

// Scripts Nubee

// import PageMenu from 'partials/page-menu.js';
// import toggleSearchForm from 'partials/toggle-search-form.js';
// import * as nubeeLoading from 'partials/nubee-loading.js';
import SmoothScroller from 'partials/smooth-scroller.js';
// import Tabs from 'partials/tabs.js';
import Accordion from 'partials/accordion.js';
import * as functions from 'partials/functions.js';
import 'partials/scroll-interval.js';
import 'partials/target-blank-security.js';
// import placeholderLabelUpdate from 'partials/placeholder-label.js';
import GLightboxNubee from 'partials/glightbox-nubee.js';
import MobileMenu from 'partials/mobile-menu.js';
import imgCheck from 'partials/img-check.js';
import InfiniteScrollSimple from 'partials/infinite-scroll-simple.js';
import LoadingButton from 'partials/loading-button.js';
// import FakeSticky from 'partials/fake-sticky.js';
import * as cookiesBar from 'partials/cookies-bar.js';
import * as ilcq_func from 'partials/ilcq-functions.js';
// import ProgressiveMenu from 'partials/progressive-menu.js';
import FilterPostsSelect from 'partials/filter-posts-select.js';
// import FilterPosts from 'partials/filter-posts.js';

import googleMapStyles from 'data/google-map-styles.js';
import PlaceGoogleMap from 'partials/place-google-map.js';

// On set toutes les variables globales et évènements qui les modifient ici
import * as globalVarFunctions from 'partials/global-variables.js';

(function() {
	/*** Application des polyfills ********************************************************************/

	(function() {
		objectFitImages();
		smoothscroll.polyfill();

		if( 'function' != typeof window.Event ) {
			window.Event = CustomEvent;
		}
	}) ();


	/*** Variables globales ***************************************************************************/
	// global-variables.js
	// Chaînes traduisibles et autres variables provenant de theme-functions : window.nubeeGlobals.i18n.monPlugin.nomDeChaine

	globalVarFunctions.setGlobalVariables();

	window.thePlaceGoogleMap = null;


	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres *******************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();


	/*** Défiler doucement les liens ancres *******************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js
	// Ajuster la variable globale window.fixedElHeight

	(function() {
		if( window.smoothScroller ) {
			let smoothScrollLinks = document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.no-smooth-scroll):not([target])');

			smoothScrollLinks.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.addEventListener( 'click', function( event ) {
						if( 1 == event.which ) {
							event.preventDefault();
							window.smoothScroller.scrollTo({ target: thisEl.hash });
						}
					} );
				}
			});
		}
	}) ();


	/*** Ne rien faire au clic sur un lien vide (#) ************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) && functions.scriptsOk( linkClicked ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();


	/*** Images et backgrounds différents selon la taille de l'écran ********************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds *******************************************************************/
	// Requiert vanilla-lazyload

	(function() {
		let loadedEvent = new Event( 'lazyloaded' );

		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			// use_native: true,
			callback_loaded: function( element ) {
				element.dispatchEvent( loadedEvent );
			},
		});
	}) ();


	/*** Google Maps ******************************************************************************************/
	// Requiert google-map.js
	// Requiert data/google-map-styles.js (copier-coller votre style là-dedans!)

	/*(function() {
		let mapParents = document.querySelectorAll('.the-map');

		mapParents.forEach( function( thisParent ) {
			if( functions.scriptsOk( thisParent ) && thisParent.querySelector( '.marker' ) !== null ) {
				new GoogleMap({
					mapParent: thisParent,
					styles: googleMapStyles,
					markerIconUrl: window.nubeeGlobals.themeDir + '/assets/images/map-marker.svg'
				});
			}
		} );
	}) ();

	/*** Place Google Maps ******************************************************************************************/
	// Requiert place-google-map.js
	// Requiert data/google-map-styles.js (copier-coller votre style là-dedans!)

	(function() {
		let mapParents = document.querySelectorAll('.page-block-map-place .the-map, .page-block-map-cooperation .the-map');

		if( mapParents !== null && mapParents.length > 0 ) {
			mapParents.forEach( function( thisParent ) {
				if( functions.scriptsOk( thisParent ) && thisParent.querySelector( '.marker' ) !== null ) {
					window.thePlaceGoogleMap = new PlaceGoogleMap({
						mapParent: thisParent,
						styles: googleMapStyles,
						markerIconUrl: window.nubeeGlobals.themeDir + '/assets/images/map-marker.svg',
						clusterIconUrl: window.nubeeGlobals.themeDir + '/assets/images/map-cluster.svg'
					});
				}
			} );
		}
	}) ();




	/*** Antispam maison sur les commentaires ****************************************************************/
	// À moins d'avoir activé le JS, la validation PHP refusera le commentaire.

	(function() {
		let commentForms = document.querySelectorAll('#commentform');

		commentForms.forEach( function( thisForm ) {
			thisForm.addEventListener( 'submit', function() {
				let legitInput = document.createElement( 'input' );
				legitInput.setAttribute( 'type', 'hidden' );
				legitInput.setAttribute( 'name', 'is_legit' );
				legitInput.value = 1;

				thisForm.appendChild( legitInput );
			} );
		} );
	}) ();


	/*** Mettre les label Gravity Forms en mode focus quand ils ont une valeur *************************/
	(function() {
		document.querySelectorAll( '.gfield' ).forEach( function( thisFormRow ) {
			thisFormRow.querySelectorAll( 'input, textarea, select' ).forEach( function( thisField ) {
				if( thisField.value !== '' ) { thisFormRow.classList.add( 'has-value' ); }

				thisField.addEventListener( 'change', function(){
					if( thisField.value !== '' ) {
						thisFormRow.classList.add( 'has-value' );
					} else {
						thisFormRow.classList.remove( 'has-value' );
					}
				} );
			} );
		} );
	}) ();


	/*** Retour en haut **************************************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let backToTop = document.querySelector('.back-to-top');

		if( backToTop && functions.scriptsOk( backToTop ) ) {
			backToTop.addEventListener( 'click', function() {
				if( 1 == event.which ) {
					window.smoothScroller.scrollTo({ target: document.body });
				}
			} );
		}
	}) ();


	/*** Menu mobile maison **********************************************************************************/

	(function() {
		new MobileMenu({
			menuSel: '.mobile-menu',
			buttonSel: '.mobile-menu-button',
			// debug: true,
			dropdownParentLinkActive: false,

			// Si on agrandit la fenêtre dans ce media query, le menu se ferme automatiquement.
			closeMediaQuery: '(min-width: 1000px)',

			// viewportMax: { width: 699 },
		});
	}) ();


	/*** InfiniteScrollSimple - Version maison plus légère *************************************************/
	// Requiert infinite-scroll-simple.js
	// Requiert regenerator-runtime (Babel veut ça pour les fonctions async)
	// Voir le début du fichier pour des events sur lesquels vous hooker

	(function() {
		let infiniteContainers = document.querySelectorAll('.iss-container');

		infiniteContainers.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new InfiniteScrollSimple({
					container: thisEl,
					useInner: true,
					animate: true,
					hideButton: false,
					// debug: true,
				});
			}
		} );

	}) ();


	/*** LoadingButton - bouton pour AJAX avec preloader intégré *******************************************/

	(function() {
		let buttons = document.querySelectorAll('.loading-button');

		buttons.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new LoadingButton({
					buttonEl: thisEl,
					debug: false,
				});

				// Le bouton est maintenant initialisé. On peut l'activer avec les méthodes :
				// buttonInstance.loadingStart() | buttonInstance.loadingEnd()
				// Fonctionnent aussi :
				// thisEl._loadingButton.loadingStart() | thisEl._loadingButton.loadingEnd()
			}
		} );
	}) ();



	/*** Infinite Scroll - Charger les prochains articles automatiquement **********************************/
	// Requiert infinite-scroll.pkgd.min.js
	/*
	(function() {
		let infiniteContainers = document.querySelectorAll('.infinite-scroll');

		infiniteContainers.forEach(function( thisEl ) {
			if( thisEl.parentNode.querySelector('.pagination .next') ) {
				let infiniteInstance = new InfiniteScroll(
					'.infinite-scroll',
					{
						path: '.pagination .next',
						append: '.infinite-scroll-element',
						prefill: false,
						history: false,
						// outlayer: outlayer,
						hideNav: '.pagination',
						status: '.infinite-scroll-status',
						debug: false,
					}
				);

				infiniteInstance.on( 'append', function( event, response, path, items ) {
					thisEl.parentNode.querySelector('.infinite-scroll-status').style.display = 'none';
					imgCheck();
					window.siteLazyLoad.update();
				} );
			}
		});
	}) ();
	*/


	/*** Sliders Swiper Partners ********************************************************************************/
	// Requiert Swiper

	(function() {
		new Swiper( '.page-block-partners .swiper', {
			modules: [ Autoplay ],
			speed: 400,
			spaceBetween: 20,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: true,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			autoplay: {
				delay: 2500,
			},
			lazy: {
				loadPrevNext: true,
			},
			breakpoints: {
				500: {
				  slidesPerView: 2,
				  spaceBetween: 20,
				},
				700: {
				  slidesPerView: 3,
				  spaceBetween: 30,
				},
				1000: {
				  slidesPerView: 4,
				  spaceBetween: 40,
				},
				1800: {
					slidesPerView: 6,
					spaceBetween: 40,
				},
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});
	}) ();

	(function() {
		new Swiper( '.page-block-latest-events .swiper', {
			modules: [ Pagination, Autoplay ],
			speed: 400,
			spaceBetween: 30,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: true,
			grabCursor: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			lazy: {
				loadPrevNext: true,
			},
			autoplay: {
				delay: 4500,
			},
			pagination: {
				el: ".swiper-pagination",
				type: 'bullets',
				clickable: true,
			},
			breakpoints: {
				1000: { slidesPerView: 2, },
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();

/* 	(function() {
		new Swiper( '.page-block-latest-news .swiper', {
			modules: [ Navigation, Autoplay ],
			speed: 400,
			spaceBetween: 60,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: false,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: false,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				500: { slidesPerView: 2, },
				1000: { slidesPerView: 3, },
				1900: { slidesPerView: 4, },
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();
 */
/* 	(function() {
		new Swiper( '.page-block-testimonials .swiper', {
			modules: [ Navigation, Autoplay ],
			speed: 400,
			spaceBetween: 25,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			autoplay: {
				delay: 5000,
			},
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				1000: { slidesPerView: 2, spaceBetween: 50, autoplay: false, },
				1800: { slidesPerView: 2, spaceBetween: 75, autoplay: false, },
				1950: { slidesPerView: 3, spaceBetween: 75, autoplay: false, },
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) (); */


	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ***********************/

	(function() {
		let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

		window.addEventListener( 'load', function() {
			lockedHeightEls.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.style.height = thisEl.offsetHeight + 'px';
					thisEl.style.minHeight = 0;
					thisEl.style.maxHeight = 'none';
				}
			} );
		} );
	}) ();


	/*** Select qui redirigent quand on choisit une option ******************************************************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linkSelects = document.querySelectorAll('.link-select');

		linkSelects.forEach( function( thisSelect ) {
			if( functions.scriptsOk( thisSelect ) ) {
				[ 'change', 'keypress' ].forEach( function( eventName ) {
					thisSelect.addEventListener( eventName, function() {
						let selectedOption = thisSelect.options[ thisSelect.selectedIndex ];
						let targetUrl = selectedOption.dataset.url;

						if( targetUrl ) {
							if( /^#.+/.test( targetUrl ) ) {
								window.smoothScroller.scrollTo({ target: targetUrl });
							} else if( ! functions.urlsAreSamePage({ urls: targetUrl }) ) {
								window.location.href = targetUrl;
							}
						}
					} );
				} );
			}
		} );
	}) ();

	/*** Défile doucement au chargement d'une URL avec ancre ***************************************************/
	// Évènement "hashblocked" pour dire que le jump par défaut vient d'être bloqué
	// Évènement "initialscrollstart" pour dire qu'on s'apprête à faire le scroll
	// Évènement "initialscrollend" pour dire que la page est chargée ET l'ancre active est scrollée
	// S'il n'y a pas d'ancre (#) active, l'évènement est lancé dès le chargement.
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	/*(function() {
		let origHash = window.location.hash;
		let hashBlockedEvent = new Event( 'hashblocked' );
		let scrollStartEvent = new Event( 'initialscrollstart' );
		let scrollEndEvent = new Event( 'initialscrollend' );

		if( origHash ) {
			let targetEl = document.querySelector( origHash );

			if( targetEl ) {
				window.addEventListener( 'hashblocked', function() {
					window.addEventListener( 'smoothscrollend', function initialScrollEnd() {
						window.dispatchEvent( scrollEndEvent );
						window.removeEventListener( 'smoothscrollend', initialScrollEnd );
					} );

					window.dispatchEvent( scrollStartEvent );

					window.smoothScroller.scrollTo({
						target: origHash,
						historyState: history.state,
						historyAction: 'replace',
						// debug: true,
					});
				} );


				// Blocage du jump du navigateur par défaut
				setTimeout( function() {
					functions.changeHashWithoutScrolling( null, history.state, 'replace' );
					window.scrollTo( 0, 0 );
					window.dispatchEvent( hashBlockedEvent );
				}, 1 );
			} else {
				window.dispatchEvent( scrollEndEvent );
			}
		} else {
			window.dispatchEvent( scrollEndEvent );
		}
	}) ();*/


	/*** Donner la même hauteur à un groupe d'éléments **********************************************************/

	(function() {
		window.addEventListener( 'load', function() {
			let sameHeightGroups = document.querySelectorAll('.same-height-group');

			sameHeightGroups.forEach( function( thisGroup ) {
				if( functions.scriptsOk( thisGroup ) ) {
					let minWidth = thisGroup.dataset.sameHeightMinWidth || 0;
					let sameHeightEls = thisGroup.querySelectorAll('.same-height');
					let highestHeight = 0;

					if( window.vWidth >= minWidth ) {
						sameHeightEls.forEach( function( thisEl ) {
							highestHeight = Math.max( thisEl.clientHeight, highestHeight );
						} );

						sameHeightEls.forEach( function( thisEl ) {
							thisEl.style.minHeight = highestHeight + 'px';
						} );
					}
				}
			} );
		} );
	}) ();


	/*** ProgressiveFadeIn - effet d'apparition lorsque dans le viewport *****************************************/
	// Requiert functions.progressiveFadeIn
	// Options dans progressive-fade-in.scss
	(function() {
		let fadeInItems = document.querySelectorAll('.progressive-fade-in');

		fadeInItems.forEach( function( thisEl ) {
			functions.progressiveFadeIn( thisEl );

			window.addEventListener( 'scrollinterval', function() {
				functions.progressiveFadeIn( thisEl );
			} );
		} );
	}) ();


	/*** Accordion *************************************************************************************/
	// Requiert accordion.js


	(function() {
		let accordionsEl = document.querySelectorAll('.accordion .accordion-item');

		accordionsEl.forEach( function( el ) {
			new Accordion( el );
		} );
	}) ();


	/*** Lightbox et popups avec GLightbox ******************************************************************/
	// Requiert GLightbox (glightbox)
	// Requiert glightbox-nubee.js

	(function() {
		// Éléments seuls.
		let lightboxEls = document.querySelectorAll('.lightbox');
		lightboxEls.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new GLightboxNubee({
					links: thisEl,
					// debug: true,
				});
			}
		} );

		// Galeries. (Attention de donner une classe différente à chaque galerie de la page.)
		// Utilisez data-lightbox-element-class="ma-classe" sur .lightbox-gallery pour l'identifier.
		let lightboxGals = document.querySelectorAll('.lightbox-gallery');
		lightboxGals.forEach( function( thisGal ) {
			if( functions.scriptsOk( thisGal ) ) {
				new GLightboxNubee({
					galleryParent: thisGal,
					// debug: true,
				});
			}
		} );

		// On peut maintenant accéder aux instances à partir des liens ou du parent de la galerie :
		// <un lien lightbox ou un div galerie>._GLightboxNubee
		// <un lien lightbox ou un div galerie>._GLightbox
	}) ();


	/*** Aller voir s'il y a des annonces a afficher *******************************/
	( function() {

		setTimeout( function( ) {

			let formData = new FormData();

			formData.append( 'action', 'announcement' );
			formData.append( 'post_id', nubeeGlobals.current_post.post_id );
			formData.append( 'post_type', nubeeGlobals.current_post.post_type );

			fetch( nubeeGlobals.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body: formData
			})
			.then( function( response ) {
				// The API call was successful!
				return response.text();
			}).then( function( html ) {

				if( html ) {

					// Convert the HTML string into a document object
					let parser = new DOMParser(),
						doc = parser.parseFromString( html, 'text/html' ),
						announcements = document.getElementById('announcements');

					// Vider le contenu du wrapper d'annonce au cas
					var announcementsChildren = Array.prototype.slice.call( announcements.childNodes );

					// Remove each child node
					announcementsChildren.forEach( function ( child ) {
						announcements.removeChild( child );
					} );

					announcements.innerHTML = html;

					let nbAnnouncements = doc.querySelectorAll('.announcement').length;

					if( nbAnnouncements > 0 ) {
						announcements.classList.remove('is-hidden');
					}

					// Si on a plus qu'une annonce, on va transformer la bande en swiper
					if( nbAnnouncements > 1 ) {
						announcements.classList.add('swiper');

						let activeIndexEl = announcements.querySelector( '.swiper-count .current' ),
							totalSlidesEl = announcements.querySelector( '.swiper-count .total' );

						new Swiper( announcements, {
							modules: [ Pagination, Autoplay ],
							speed: 400,
							spaceBetween: 0,
							slidesPerView: 1,
							direction: 'horizontal',
							loop: false,
							touchEventsTarget: 'wrapper',
							preventInteractionOnTransition: true,
							effect: 'slide',
							preloadImages: true,
							shortSwipes: true,
							autoHeight: false,
							autoplay: {
								delay: 5000,
							},
							lazy: {
								loadPrevNext: true,
							},
							pagination: {
								el: ".swiper-pagination",
								clickable: true,
								type: "bullets",
							},
							// modules: [ Pagination, Autoplay ],
							on: {
								init: function( sw ) {
									activeIndexEl.textContent = sw.activeIndex +  1;
									totalSlidesEl.textContent = sw.slides.length;
								},
								slideChangeTransitionEnd: function( sw ) {
									activeIndexEl.textContent = sw.activeIndex +  1;
								}
							}
						});

					}

					document.getElementById('close-announcement').addEventListener( 'click', function (event) {
						event.preventDefault();

						let currentDate = new Date();

						let expirationDate = new Date(
							currentDate.getFullYear(),
							currentDate.getMonth(),
							currentDate.getDate() + 1,
							0, 0, 0
						);

						announcements.querySelectorAll( '.announcement' ).forEach( function( thisAnnouncement ) {
							document.cookie = thisAnnouncement.id + "=is-hidden; expires=" + expirationDate.toGMTString + "; path=/";
						});

						announcements.classList.add( 'is-hidden' );


					}, false );
				}


			}).catch( function( error ) {
				// There was an error
				console.warn('Something went wrong.', error);
			});

		}, 50 );

	} ) ();

	/*** Gestion des préférence de cookies ***************************************/
	(function() {
		window.acceptedCookies = cookiesBar.getCookie('acceptedCookies');

		if( 'function' == typeof cookiesBar.cookieConsent ) {
			cookiesBar.cookieConsent();
		}
	}) ();

	/*** Nombres décoratifs qui comptent vers le haut ******************************************************/
	// Requiert countUp.js
	// Pour générer des options supplémentaires https://inorganik.github.io/countUp.js/

/* 	(function() {
		var countUpNumbers = Array.prototype.slice.call( document.querySelectorAll( '.countup-number' ) );
		var countUpInstances = [];

		// Faire fonctionner l'animation seulement quand on arrive près du bloc
		window.addEventListener( 'scrollinterval', function() {
			if( 'undefined' != typeof CountUp && 0 < countUpNumbers.length ) {
				countUpNumbers.forEach( function( element, index, iteratedArray ) {
					if( element && functions.isInViewport(element) ) {
						if( ! countUpInstances[index].error ) {
							element.classList.add( 'countup-counting', 'countup-init' );

							countUpInstances[index].start( function() {
								element.classList.add( 'countup-counted' );
								element.classList.remove( 'countup-counting' );
							} );
						} else {
							console.error( countUpInstances[index].error );
						}

						// On vient de lancer CountUp sur cet élément. On l'enlève de la liste des éléments à traiter.
						iteratedArray[index] = null;
					}
				} );
			}
		}, 50 );

		// Les options pour faire fonctionner l'animation
		if( 'undefined' != typeof CountUp && 0 < countUpNumbers.length ) {
			countUpNumbers.forEach( function( element, index, iteratedArray ) {
				const endNumber = parseFloat( element.innerHTML.trim() );
				const easingFn = function (t, b, c, d) {
					var ts = (t /= d) * t;
					var tc = ts * t;
					return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
				}
				const options = {
					easingFn,
					duration: 2, // Temps en seconde
				};

				countUpInstances.push( new CountUp( element, endNumber, options ) );

			});
		}

	}) (); */


	/*** Changer le type de vue dans la page des événements ******************************************************/
	(function() {
		const toggleButton = document.getElementById('toggle-view');
		const postList = document.querySelector('.post-list-event');
		const calendarView = document.querySelector('.event-calendar');
		const urlParams = new URLSearchParams(window.location.search);
		const hasDateParam = /\d{4}-\d{2}-\d{2}/.test(window.location.pathname);
		const viewParam = urlParams.get('view');

		// Vérification des éléments nécessaires
		if( ! postList ) {
			return;
		}

		// Détermine la vue par défaut
		let defaultView;

		if( hasDateParam ) {
			// Si une date est présente, forcer la vue "list"
			defaultView = 'list';
		} else if ( viewParam ) {
			// Si une vue est spécifiée dans l'URL, l'utiliser
			defaultView = viewParam;
		} else {
			// Sinon, récupérer la vue enregistrée ou défaut à "list"
			defaultView = localStorage.getItem('currentView') || 'list';
		}

		function updateView(view) {
			if( view === 'calendar' ) {
				postList.classList.remove('fade-in-visible');
				postList.style.display = 'none';
				calendarView.style.display = 'block';
				calendarView.classList.add('fade-in-visible');
				if( toggleButton ) {
					toggleButton.textContent = nubeeGlobals.i18n.functions.listView;
					toggleButton.setAttribute('data-view', 'calendar');
				}
			} else {
				calendarView.classList.remove('fade-in-visible');
				calendarView.style.display = 'none';
				postList.style.display = 'block';
				postList.classList.add('fade-in-visible');
				if( toggleButton ) {
					toggleButton.textContent = nubeeGlobals.i18n.functions.calendarView;
					toggleButton.setAttribute('data-view', 'list');
				}
			}
		}

		// Initialiser la vue en fonction de la logique ci-dessus
		updateView(defaultView);

		// Gestion du bouton pour basculer entre les vues
		if( toggleButton ) {
			toggleButton.addEventListener('click', function () {
				const currentView = toggleButton.getAttribute('data-view');
				const newView = currentView === 'list' ? 'calendar' : 'list';
				localStorage.setItem('currentView', newView);
				updateView(newView);
			});
		}

	}) ();

	/*** Calculer le width dynamiquement du rond des boutons half naked ******************************************************/
	(function() {
		const buttons = document.querySelectorAll(".button.half-naked.arrow-after");

		buttons.forEach((button) => {
			// Fonction pour mettre à jour la largeur dynamique
			const updateCircleWidth = () => {
				let buttonHeight = button.offsetHeight;

				if( buttonHeight < 59 ) { buttonHeight = 59; }

				button.style.setProperty("--circle-size", `${buttonHeight}px`);
			};

			// Met à jour au chargement et sur redimensionnement
			updateCircleWidth();
			window.addEventListener("resize", updateCircleWidth);
		});
	}) ();

	/*** Enlever le width sur le input du sélecteur de mois du calendrier ******************************************************/
	(function() {
		const monthPicker = document.querySelector('input.em-month-picker.flatpickr-input.select-toggle');
		if( monthPicker ) {
			monthPicker.style.width = ''; // Enlève le style inline
		}
	}) ();

	/*** Faire fonctionner le clic sur les régions du Québec de la carte en SVG *******************************************/
	(function() {

		const mapRegionsQuebec = document.querySelectorAll( '.map-regions-quebec' );

		if( mapRegionsQuebec.length > 0 ) {

			mapRegionsQuebec.forEach( function( thisMap ) {

				document.querySelectorAll( '.region' ).forEach( function( thisRegion ) {
					thisRegion.addEventListener( 'click', function() {
						window.location = nubeeGlobals.placesMapUrl + '?ilcq-region=' + thisRegion.dataset.regionId;
					} );
				} );

			} );

		}

	}) ();

	/*** Dans l'affichage de liste des lieux de culte, on va s'arranger pour que les select region/mrc/municipality
	 * soit associés à la recherche texte
	***/
	(function() {

		const is_listing_page = document.body.classList.contains( 'post-type-archive-place' );

		if( is_listing_page ) {

			document.querySelector( 'form[name=search-ilcq]' ).addEventListener( 'submit', function ( e ) {
				e.preventDefault();

				let url = new URL( window.location.href );
				let params = new URLSearchParams( url.search );

				let regionVal = document.getElementById( 'region_filter' ).value;
				let mrcVal = document.getElementById( 'mrc_filter' ).value;
				let municipalityVal = document.getElementById( 'municipality_filter' ).value;

				// Get the current query parameters and append them to the form's action
				let searchInput = document.getElementById( 'search-ilcq-input' ).value;
				if ( searchInput ) {
					params.set( 'ilcq-search', searchInput ); // Ensure search input is included

					if( regionVal !== '' ) { params.set( 'ilcq-region', regionVal ); }
					if( mrcVal !== '' ) { params.set( 'ilcq-mrc', mrcVal ); }
					if( municipalityVal !== '' ) { params.set( 'ilcq-municipality', municipalityVal ); }
				} else {
					params.delete( 'ilcq-search' );
				}

				// Update form action to include all params
				window.location = `${url.pathname}?${params.toString()}`;
			});

		}

	}) ();

	/*** Affichager "chained" des select de filtre des lieux de cultes *******************************************/
	(function() {

		let chained_regions_select = document.querySelectorAll( '.chained-regions-select' ),
			searchField;

		if( chained_regions_select.length > 0 ) {

			const is_listing_page = document.body.classList.contains( 'page-template-page-ilcq-map' ) || document.body.classList.contains( 'post-type-archive-place' );
			const toggleMapListBtn = document.getElementById( 'toggleMapList' );

			if( is_listing_page ) {
				searchField = document.getElementById( 'search-ilcq-input' );
			}

			chained_regions_select.forEach( function( thisWrapper ) {

				const regionField = thisWrapper.querySelector( 'select[name="ilcq-region"]' ),
					  mrcField = thisWrapper.querySelector( 'select[name="ilcq-mrc"]' ),
					  mrcFieldEmptyValue = mrcField.querySelector('option[value=""]'),
					  municipalityField = thisWrapper.querySelector( 'select[name="ilcq-municipality"]' ),
					  municipalityFieldEmptyValue = municipalityField.querySelector('option[value=""]'),

					  updatePostList = thisWrapper.classList.contains( 'update-post-list' ) && document.querySelector('.post-list-place') != null,
					  updateMarkerList = window.thePlaceGoogleMap !== null,

					  theForm = regionField.closest('.the-form'),
					  theFormAction = theForm !== null ? theForm.action : false;

				let filterUrl, filterPostsSelect;

				if( updatePostList ) {
					filterPostsSelect = new FilterPostsSelect({
						form: theForm,
						container: document.querySelector('.post-list-place'),
						useInner: true,
						animate: true,
						debug: false,
					});
				}

				regionField.addEventListener( 'change', function(){

					mrcField.disabled = true;
					municipalityField.disabled = true;

					if( regionField.value !== '' ) {
						ilcq_func.updateMrcSelect( parseInt( regionField.value ), mrcField, municipalityField );
					} else {
						mrcField.disabled = true;
						mrcFieldEmptyValue.selected = true;
						municipalityField.disabled = true;
						municipalityFieldEmptyValue.selected = true;
					}

					if( updatePostList ) {
						filterPostsSelect.doNewPostRequest();
					} else if( updateMarkerList ) {
						window.thePlaceGoogleMap.updateMarkers( parseInt( regionField.value ) );
					}

					// On va mettre à jour l'URL
					if( is_listing_page && history.pushState ) {
						if( searchField !== undefined && searchField.value ) { functions.updateQueryParam( 'ilcq-search', searchField.value ); }
						functions.updateQueryParam( 'ilcq-region', regionField.value );
						functions.updateQueryParam( 'ilcq-mrc', mrcField.value );
						functions.updateQueryParam( 'ilcq-municipality', municipalityField.value );
					}

					// Si le bouton pour toggle Map/List existe, on va updater son url
					if( toggleMapListBtn !== null ) {
						ilcq_func.updateAnchorHref( toggleMapListBtn, { 'ilcq-region': regionField.value } );
					}

				} );

				mrcField.addEventListener( 'change', function(){

					if( mrcField.value !== '' ) {
						ilcq_func.updateMunicipalitiesSelect( parseInt( mrcField.value ), municipalityField );
					} else {
						municipalityField.disabled = true;
						municipalityFieldEmptyValue.selected = true;
					}

					if( updatePostList ) {
						filterPostsSelect.doNewPostRequest();
					} else if( updateMarkerList ) {
						window.thePlaceGoogleMap.updateMarkers( parseInt( regionField.value ), parseInt( mrcField.value ) );
					}

					// On va mettre à jour l'URL
					if( is_listing_page && history.pushState ) {
						if( searchField !== undefined && searchField.value ) { functions.updateQueryParam( 'ilcq-search', searchField.value ); }
						functions.updateQueryParam( 'ilcq-region', regionField.value );
						functions.updateQueryParam( 'ilcq-mrc', mrcField.value );
						functions.updateQueryParam( 'ilcq-municipality', municipalityField.value );
					}

					// Si le bouton pour toggle Map/List existe, on va updater son url
					if( toggleMapListBtn !== null ) {
						ilcq_func.updateAnchorHref( toggleMapListBtn, { 'ilcq-mrc': mrcField.value } );
					}

				} );

				municipalityField.addEventListener( 'change', function(){
					if( updatePostList ) {
						filterPostsSelect.doNewPostRequest();
					}

					if( updateMarkerList ) {
						window.thePlaceGoogleMap.updateMarkers(
							parseInt( regionField.value ),
							parseInt( mrcField.value ),
							parseInt( municipalityField.value )
						);
					}

					// On va mettre à jour l'URL
					if( is_listing_page && history.pushState ) {
						if( searchField !== undefined && searchField.value ) { functions.updateQueryParam( 'ilcq-search', searchField.value ); }
						functions.updateQueryParam( 'ilcq-region', regionField.value );
						functions.updateQueryParam( 'ilcq-mrc', mrcField.value );
						functions.updateQueryParam( 'ilcq-municipality', municipalityField.value );
					}

					// Si le bouton pour toggle Map/List existe, on va updater son url
					if( toggleMapListBtn !== null ) {
						ilcq_func.updateAnchorHref( toggleMapListBtn, { 'ilcq-municipality': municipalityField.value } );
					}
				} );

			} );

		}

	}) ();

	(function() {
		const ilcq_advanced_search_popup = document.getElementById('ilcq_advanced_search_popup');

		if( ilcq_advanced_search_popup !== null ) {
			const ilcq_advanced_search_popup_form = ilcq_advanced_search_popup.querySelector( '.the-avanced-ilcq-form' );

			document.querySelectorAll( '.advanced-search-link' ).forEach( function( thisEl ){

				thisEl.addEventListener( 'click', function() {

					// Blocage du scroll
					disableBodyScroll( ilcq_advanced_search_popup, { reserveScrollBarGap: true, allowTouchMove: () => true } );

					ilcq_advanced_search_popup.classList.remove( 'hidden' );

				} );
			} );

			ilcq_advanced_search_popup.querySelector( '.button-close' ).addEventListener( 'click', function() {
				// Réactivation du scroll
				enableBodyScroll( ilcq_advanced_search_popup, { reserveScrollBarGap: true, allowTouchMove: () => true } );

				ilcq_advanced_search_popup.classList.add( 'hidden' );
			} );

			// On va empêcher les champs vide d'être soumis pour rien dans la querystring
			ilcq_advanced_search_popup_form.addEventListener( 'submit', function( ) {

				this.querySelectorAll('input, select, textarea').forEach( input => {
					if (!input.value || (input.type === 'checkbox' && !input.checked)) {
						input.name = ''; // Remove empty fields by clearing their name
					}
				});

			} );
		}

	}) ();
}) ();